import { PRINTING_TYPES } from "/cdn/shop/t/98/assets/printingOptions.constant.js?cash48";

export class ReviewObject {
    constructor(obj) {
        this.first_name = obj?.first_name || obj?.customer_name_first;
        this.last_name = obj?.last_name || obj?.customer_name_last;
        this.email = obj?.customer_email || obj?.email;
        this.phone_number = obj?.phone_number || obj?.customer_phone;
        this.company = obj?.company || obj?.customer_company;
        this.embroidery = this.getGarmentType(obj?.embroidery);
        this.dye_sublimation = this.getGarmentType(obj?.dye_sublimation);
        this.direct_to_garment = this.getGarmentType(obj?.direct_to_garment);
        this.other = obj?.other;
        this.printing_types = this.getActivePrintingTypes(obj?.printing_types);
    }

    getActivePrintingTypes(printing_types) {
        if (printing_types) return printing_types.map(type => type?.name);

        const activePrintingTypes = [];

        Object.keys(PRINTING_TYPES)?.filter(type => this[type]).forEach(type => {
            activePrintingTypes.push(type);
        });

        return activePrintingTypes;
    }

    getGarmentType(data) {
        if (!data || !data?.garment_options?.length) return null;

        if (typeof data?.garment_options?.[0] !== "string") return data;

        const garmentOptions = [];

        data?.garment_options.forEach(option => {
            const garment = {
                garment: option,
                count: data?.[option]?.count
            };

            if (data?.[option]?.printing_locations) {
                garment.printing_locations = data?.[option]?.printing_locations;
            }

            garmentOptions.push(garment);
        });

        return {
            garment_options: garmentOptions,
            files: data?.files,
        }
    }
}